import { connect } from 'react-redux'
import { email } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'

import {
  doSignupAccount,
  doRedirectToHomeIfAuthenticated,
  doGoogleSignup,
  doOfficeSignup,
} from '../actions'

import { selectFormFields } from '../selectors'

import SignupFormView from './view'

const validators = {
  emailInput: email,
}

const select = state => ({
  initialValues: selectFormFields(state),
  validators,
})

const perform = {
  onSave: doSignupAccount,
  redirectToHomeIfAuthenticated: doRedirectToHomeIfAuthenticated,
  doGoogleSignup,
  doOfficeSignup,
}

export default connect(select, perform)(withFormFields(SignupFormView))
